<div class="step-content">
  <ng-content></ng-content>
</div>
